import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260205-sanboard",
        datum: "05.02.2026",
        kategorie: KategorieEnum.COMMUNITY,
        type: InsightTypeEnum.INTERVIEW,
        title: "Digitales Patientenprotokoll in HiOrg-Server",
        lizenz: [LizenzEnum.PRO],
        content: [
            "Wir prüfen aktuell, ob und wie digitale Patientenprotokolle sinnvoll in den HiOrg-Server integriert werden" +
            " können. Wenn ihr euch grundsätzlich eine praxisnahe Alternative zu Papierformularen und aufwendiger" +
            " Hardware vorstellen könnt, freuen wir uns über eure Rückmeldung.",
            "Interesse vormerken & mitgestalten: Du bist verantwortlich in deiner Organisation, im Bereich" +
            " Sanitätsdienst oder zuständig für die Patientenprotokolle? Trag dich auf die Warteliste ein und gib uns" +
            " Feedback zu Bedarf, Anforderungen und Rahmenbedingungen.<br>" +
            "Ausgewählte Organisationen erhalten zudem die Möglichkeit, eine Testversion frühzeitig auszuprobieren."
        ],
        aktions: [
            {
                type: AktionTypeEnum.LINK,
                text: "Interesse vormerken & mitgestalten",
                url: "https://waitlist.hiorg-server.de/patientenprotokoll?utm_source=insights",
            },
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/02/digitales-patientenprotokoll-in-hiorg-server/",
            },
        ],
    },
];

export {
    insights,
};
